// data.service.ts
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../_services/app.service';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Helpers } from '../../../helpers';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class ConsignmentsService {
      
    IndentId:any;
    UserId:any;
    TransporterId:any;
    TransporterName:any;
    ShortName:any;
    constructor(
        private _appService: appService, 
        private translate: TranslateService,
        private toastr: ToastrService, 
        private datePipe: DatePipe, 
        private modalService: NgbModal
    ) { }

    async onClickDataByIdConsignment(LeadTime:any, service_code:any, TotalRate:any) {
        return await new Promise(async (resolve1, reject1) => {
        this._appService.GetById("OrdersByVehicle", "oc_GetCourierDataByIdConsignment", this.IndentId).subscribe(
          (response) => {
            var obj: any = {};
            obj.OrderDetails = response.Table[0];
            obj.ProductDetails = response.Table1;
            obj.ProductDimentions = response.Table2;
            obj.InvoiceDetails = response.Table3;
            obj.AdditionalServices = response.Table4;
            obj.OrdersPackage = response.Table5;

            var ConsignmentList: any = [];
            ConsignmentList.push(obj);
            this.CreateConsignment(obj,this.ShortName,this.IndentId,this.TransporterId,this.TransporterName,LeadTime,service_code,TotalRate);
            // resolve1("OK");
            resolve1({
                isSuccess: true,
                response: response
            });
          },
          (err) => {
            this.toastr.error(err._body.replace(/"/g, ""), "Error");
            // resolve1("OK");
            resolve1({
                isSuccess: false,
                response: err
            });
          });
      });
    }

    async CreateConsignment(
        a: any,
        TransporterShortName: any,
        OrderId: any,
        TransporterId: any,
        TransporterName: any,
        LeadTime: any,
        service_code: any,
        TotalRate: any
    ) {
        var data: any = {};

        data.consignment = {};
        data.consignment.consolidate = 'No'; //this.DiffLocations == true ? 'No' : 'Yes';
        data.consignment.shipper_company_code = a.OrderDetails.PickupLocationCode;
        data.consignment.consignment_number = '';
        data.consignment.is_draft = "No";
        data.consignment.from_challan_id = "";
        data.consignment.consignor_company_id = "";
        data.consignment.consignor_company_name = a.OrderDetails.ConsignorCompany;
        data.consignment.consignor_company_code = a.OrderDetails.ConsignorCode;
        data.consignment.consignor_facility_name = a.OrderDetails.PickupCity;
        data.consignment.consignor_facility_code = a.OrderDetails.PickupLocationCode;
        data.consignment.consignor_address_line1 = a.OrderDetails.ConsignerAddress;
        data.consignment.consignor_address_line2 = "";
        data.consignment.consignor_city = a.OrderDetails.ConsignerCity;
        data.consignment.consignor_state = a.OrderDetails.ConsignerState;
        data.consignment.consignor_pin = a.OrderDetails.ConsignerPincode;
        data.consignment.consignor_contact_name = a.OrderDetails.PickUpContactPerson;
        data.consignment.consignor_phone = a.OrderDetails.PickUpContactNumber;
        data.consignment.consignee_company_id = "";
        data.consignment.consignee_company_name = a.OrderDetails.ConsigneeName;
        data.consignment.consignee_company_code = a.OrderDetails.ConsigneeCode;
        data.consignment.consignee_facility_name = a.OrderDetails.DeliveryCity;
        data.consignment.consignee_facility_code = a.OrderDetails.DeliveryLocationCode;
        data.consignment.consignee_address_line1 = a.OrderDetails.ConsigneeAddress;
        data.consignment.consignee_address_line2 = "";
        data.consignment.consignee_city = a.OrderDetails.ConsigneeCity;
        data.consignment.consignee_state = a.OrderDetails.ConsigneeState;
        data.consignment.consignee_pin = a.OrderDetails.ConsigneePincode;
        data.consignment.consignee_contact_name = a.OrderDetails.DeliveryContactPerson;
        data.consignment.consignee_phone = a.OrderDetails.DeliveryContactNumber;
        data.consignment.reference_number_1 = a.OrderDetails.ReferenceNo;
        data.consignment.reference_number_2 = "";
        data.consignment.service_option = 'SURF XPRS'; //a.OrderDetails.TransportName;
        data.consignment.truck_category = "";
        data.consignment.service_provider_company_code = TransporterShortName;
        data.consignment.vehicle_number = "";
        data.consignment.driver_name = "";
        data.consignment.driver_mobile_number = "";
        data.consignment.volume = ""; //a.OrderDetails.Volume;
        data.consignment.volume_measure = "";
        data.consignment.ready_for_pickup_at = a.OrderDetails.PickupLocationCode;
        data.consignment.payment_mode = 'To Bill'; //a.OrderDetails.Freight;
        data.consignment.slot_date = "";
        data.consignment.slot_name = "";
        data.consignment.slot_company_code = "";
        data.consignment.weight = a.OrderDetails.Weight;
        data.consignment.billable_weight = a.OrderDetails.VolumetricWeight > a.OrderDetails.Weight == true ? a.OrderDetails.VolumetricWeight : a.OrderDetails.Weight;
        data.consignment.weight_measure = "Kgs";

        data.consignment.consignment_contents = {};
        data.consignment.consignment_contents.consignment_content = [];
        data.product_data = [];
        data.products = [];
        data.consignment_contents_common = {};
        data.consignment_contents_common.consignment_content_common = [];

        for (let k = 0; k < a.ProductDetails.length; k++) {
        var obj: any = {};

        obj.reference_number = a.OrderDetails.ReferenceNo; //ASK
        obj.delivery_number = null; //ASK
        obj.product_id = "";
        obj.product_name = 'OTHERS'; //a.ProductDetails[k].ProductName;
        obj.product_display_name = a.ProductDetails[k].ProductName;
        obj.units = a.ProductDetails[k].Qty;
        obj.unit_type = 'Units'; //a.ProductDetails[k].UnitName;
        obj.weight = a.ProductDetails[k].weight;
        obj.billable_weight = a.ProductDetails[k].VolumetricWeight > a.OrderDetails.Weight == true ? a.ProductDetails[k].VolumetricWeight : a.OrderDetails.Weight;
        obj.weight_measure = "Kgs";
        obj.length = a.ProductDetails[k].Length;
        obj.width = a.ProductDetails[k].Width;
        obj.height = a.ProductDetails[k].Height;
        obj.uom = 'inches'; //a.ProductDetails[k].UnitName;
        data.consignment.consignment_contents.consignment_content.push(obj);

        //************************************************************** */
        var obj2: any = {};
        obj2.hsnno = a.ProductDetails[k].HSNNo;
        obj2.product_name = a.ProductDetails[k].ProductName;

        var total = parseFloat(a.ProductDetails[k].Price) * parseFloat(a.ProductDetails[k].Qty);
        if (a.OrderDetails.ConsignerState == a.OrderDetails.ConsigneeState) {
            obj2.SGSTAmount = total * (9 / 100);
            obj2.CGSTAmount = total * (9 / 100);
            obj2.IGSTAmount = 0;
            obj2.GSTTaxRateCGSTN = 9;
            obj2.GSTTaxRateSGSTN = 9;
            obj2.GSTTAXRateIGSTN = 0;
        } else {
            obj2.SGSTAmount = 0;
            obj2.CGSTAmount = 0;
            obj2.IGSTAmount = total * (18 / 100);
            obj2.GSTTaxRateCGSTN = 0;
            obj2.GSTTaxRateSGSTN = 0;
            obj2.GSTTAXRateIGSTN = 18;
        }

        obj2.Discount = 0;
        obj2.GSTTaxTotal = (obj2.SGSTAmount + obj2.CGSTAmount + obj2.IGSTAmount);
        obj2.TaxableValue = total + obj2.GSTTaxTotal;
        data.product_data.push(obj2);

        //************************************************************** */
        var obj3: any = {};

        obj3.reference_number = a.OrderDetails.ReferenceNo; //ASK
        obj3.delivery_number = null; //ASK
        obj3.product_id = "";
        obj3.product_name = 'OTHERS'; //a.ProductDetails[k].ProductName;
        obj3.product_display_name = a.ProductDetails[k].ProductName;
        obj3.units = a.ProductDetails[k].Qty;
        obj3.unit_type = 'Units'; //a.ProductDetails[k].UnitName;
        obj3.weight = a.ProductDetails[k].ProductWeight;
        obj3.billable_weight = a.ProductDetails[k].VolumetricWeight > a.OrderDetails.Weight == true ? a.ProductDetails[k].VolumetricWeight : a.OrderDetails.Weight;
        obj3.weight_measure = "Kgs";
        obj3.length = a.ProductDetails[k].Length;
        obj3.width = a.ProductDetails[k].Width;
        obj3.height = a.ProductDetails[k].Height;
        obj3.uom = 'inches'; //a.ProductDetails[k].UnitName;
        obj3.hsnno = a.ProductDetails[k].HSNNo;
        obj3.price = a.ProductDetails[k].Price;
        var total = parseFloat(a.ProductDetails[k].Price) * parseFloat(a.ProductDetails[k].Qty);
        if (a.OrderDetails.ConsignerState == a.OrderDetails.ConsigneeState) {
            obj3.SGSTAmount = total * (9 / 100);
            obj3.CGSTAmount = total * (9 / 100);
            obj3.IGSTAmount = 0;
            obj3.GSTTaxRateCGSTN = 9;
            obj3.GSTTaxRateSGSTN = 9;
            obj3.GSTTAXRateIGSTN = 0;
        } else {
            obj3.SGSTAmount = 0;
            obj3.CGSTAmount = 0;
            obj3.IGSTAmount = total * (18 / 100);
            obj3.GSTTaxRateCGSTN = 0;
            obj3.GSTTaxRateSGSTN = 0;
            obj3.GSTTAXRateIGSTN = 18;
        }
        obj3.Discount = 0;
        obj3.GSTTaxTotal = (obj3.SGSTAmount + obj3.CGSTAmount + obj3.IGSTAmount);
        obj3.TaxableValue = total + obj3.GSTTaxTotal;
        data.products.push(obj3);

        var obj4: any = {};

        obj4.reference_number = a.OrderDetails.ReferenceNo; //ASK
        obj4.delivery_number = null; //ASK
        obj4.product_id = "";
        obj4.product_name = 'OTHERS'; //a.ProductDetails[k].ProductName;
        obj4.product_display_name = a.ProductDetails[k].ProductName;
        obj4.units = a.ProductDetails[k].Qty;
        obj4.unit_type = 'Units'; //a.ProductDetails[k].UnitName;
        obj4.weight = a.ProductDetails[k].weight;
        obj4.billable_weight = a.ProductDetails[k].VolumetricWeight > a.OrderDetails.Weight == true ? a.ProductDetails[k].VolumetricWeight : a.OrderDetails.Weight;
        obj4.weight_measure = "Kgs";
        obj4.length = a.ProductDetails[k].Length;
        obj4.width = a.ProductDetails[k].Width;
        obj4.height = a.ProductDetails[k].Height;
        obj4.uom = 'inches'; //a.ProductDetails[k].UnitName;
        obj4.Barcode = a.ProductDetails[k].Barcode;
        obj4.product_code = a.ProductDetails[k].ProductCode;
        obj4.Category = a.ProductDetails[k].Category;
        data.consignment_contents_common.consignment_content_common.push(obj4);
        }

        data.consignment.consignment_invoices = {};
        data.consignment.consignment_invoices.consignment_invoice = [];
        for (let k = 0; k < a.InvoiceDetails.length; k++) {
        var obj: any = {};

        obj.invoice_number = a.InvoiceDetails[k].InvoiceNo;
        obj.delivery_number = null; //ASK
        obj.invoice_value = a.InvoiceDetails[k].Amount;
        obj.invoice_date = a.InvoiceDetails[k].InvoiceDate;
        obj.cod_amount = a.InvoiceDetails[k].Amount;
        obj.weight = a.OrderDetails.Weight;
        obj.billable_weight = a.InvoiceDetails[k].VolumetricWeight > a.OrderDetails.Weight ? a.InvoiceDetails[k].VolumetricWeight : a.OrderDetails.Weight;
        obj.weight_measure = "Kgs";
        obj.pickable_units = a.InvoiceDetails[k].Qty;
        obj.eway_bill_number = a.InvoiceDetails[k].eWayBill;
        obj.eway_bill_expiry_date = a.InvoiceDetails[k].eWayBillExpiryDate;
        data.consignment.consignment_invoices.consignment_invoice.push(obj);
        }

        data.parcellist = [];
        for (let k = 0; k < a.OrdersPackage.length; k++) {
        var obj: any = {};
        obj.weight = a.OrdersPackage[k].GrossWeight;
        obj.length = a.OrdersPackage[k].Length;
        obj.height = a.OrdersPackage[k].Height;
        obj.width = a.OrdersPackage[k].Width;
        obj.item_description = a.OrdersPackage[k].ProductName;
        obj.no_of_items = a.OrdersPackage[k].TotalPackages;
        obj.item_value = a.OrdersPackage[k].InvoiceAmount;
        obj.hscode = a.OrdersPackage[k].HSNNo;
        data.parcellist.push(obj);
        }

        data.consignment.service_provider_id = "";
        data.consignment.service_provider_name = "";
        data.consignment.service_provider_code = "";
        data.consignment.consignment_type = "OUTBOUND-TBB";
        data.OrderId = OrderId;
        data.TransporterId = TransporterId;
        data.PickUpDateTime = a.OrderDetails.PickupDate;
        data.consignor_email = a.OrderDetails.PickUpContactEmail;
        data.consignee_email = a.OrderDetails.DeliveryContactEmail;
        data.consignor_lat = a.OrderDetails.PickUpLatitude;
        data.consignor_long = a.OrderDetails.PickUpLongtitude;
        data.consignee_lat = a.OrderDetails.DeliverLatitude;
        data.consignee_long = a.OrderDetails.DeliverLongtitude;
        data.tax_id = a.OrderDetails.PickupGSTNo;
        data.consignor_country = a.OrderDetails.PickupCountry;
        data.consignee_country = a.OrderDetails.DeliveryCountry;
        data.VolumetricWeight = a.OrderDetails.VolumetricWeight;
        data.PickupDateV2 = a.OrderDetails.PickupDateV2;

        data.Customer = {};
        data.Customer.CustomerAddress1 = a.OrderDetails.CustomerAddress;
        data.Customer.CustomerAddress2 = "";
        data.Customer.CustomerAddress3 = "";
        data.Customer.CustomerEmailID = a.OrderDetails.CustomerMail;
        data.Customer.CustomerGSTNumber = a.OrderDetails.CustomeGST;
        data.Customer.CustomerLatitude = "";
        data.Customer.CustomerLongitude = "";
        data.Customer.CustomerMobile = a.OrderDetails.CustomerMobile;
        data.Customer.CustomerName = a.OrderDetails.CustomerName;
        data.Customer.CustomerPincode = a.OrderDetails.CustomerPincode;
        data.service_code = service_code;

        console.log('CreateConsignment Method Data',data);
        Helpers.setLoading(true);
        await new Promise(async (resolve1, reject1) => {
        this._appService.Post("OrdersByVehicle", "CreateConsignment", data).subscribe(async (response) => {
                Helpers.setLoading(false);
                if (response.isScuccess == true) {
                this.toastr.success(this.translate.instant("ALERTMESSAGES.ConsignmentSuccess"),"Success");

                var ShipmentId, ShipmentNo = '';
                if (TransporterName == "Smart Track") {
                    var msg = JSON.parse(response.message);
                    ShipmentId = msg['data']['shipment_id'];
                    ShipmentNo = msg['data']['shipment_number'];
                }

                Helpers.setLoading(true);
                this._appService.GetByEightId("OrdersByVehicle","oc_ConfirmCourierData_generateInvoiceOrderWiseV2",OrderId,this.UserId,TransporterId,LeadTime,ShipmentId,ShipmentNo,service_code,TotalRate).subscribe(async (response) => {
                        Helpers.setLoading(false);
                        if (response[0].isDone == "OK") {
                        this.toastr.success("Order Confirm successfully !","Success");

                        resolve1("OK");
                        setTimeout(() => {
                        }, 1000);
                        Helpers.setLoading(false);
                        } else {
                        this.toastr.success("Error Occurred While ConFirm Booking !","Error");
                        Helpers.setLoading(false);
                        resolve1("OK");
                        }
                        if (response[0].invoiceResult != "Success") {
                        this.toastr.success("Error Occurred While Generating Shipment !","Error");
                        Helpers.setLoading(false);
                        resolve1("OK");
                        }
                    },
                    (err) => {
                        Helpers.setLoading(false);
                        this.toastr.error(err._body.replace(/"/g, ""), "Error");
                        resolve1("OK");
                    }
                    );
                } else {
                var msg = JSON.parse(response.message);

                if (TransporterName == "V-Xpress")
                    this.toastr.error(msg.exception.message, "Error");

                if (
                    TransporterName == "Delhivery" ||
                    TransporterName == "OM Logistics"
                )
                    this.toastr.error(msg.message, "Error");

                if (TransporterName == "XpressBees")
                    this.toastr.error(msg.ReturnMessage, "Error");

                if (TransporterName == "Allcargo GATI") {
                    // this.toastr.error(msg['meta']['message'], 'Error');
                    const detailsArray = msg["meta"]["details"][0];
                    if (!detailsArray.includes("{")) {
                    this.toastr.error(detailsArray, "Error", {
                        enableHtml: true,
                    });
                    } else {
                    const validJsonString = detailsArray.replace(/'/g, '"');
                    const detailsObject = JSON.parse(validJsonString);
                    let toastrMessage = "";

                    // Loop through details and format message
                    for (const key in detailsObject) {
                        if (detailsObject.hasOwnProperty(key)) {
                        const nestedObject = detailsObject[key];
                        for (const nestedKey in nestedObject) {
                            if (nestedObject.hasOwnProperty(nestedKey)) {
                            const errors = nestedObject[nestedKey];
                            if (Array.isArray(errors)) {
                                // If errors is an array, iterate over each error
                                errors.forEach((error: string) => {
                                toastrMessage += `${nestedKey}: ${error}<br>`;
                                });
                            } else if (typeof errors === "object") {
                                // If errors is an object, assume it has message arrays
                                for (const prop in errors) {
                                if (
                                    errors.hasOwnProperty(prop) &&
                                    Array.isArray(errors[prop])
                                ) {
                                    errors[prop].forEach((error: string) => {
                                    toastrMessage += `${prop}: ${error}<br>`;
                                    });
                                }
                                }
                            }
                            }
                        }
                        }
                    }
                    // Show toastr message
                    this.toastr.error(toastrMessage, "Error", {enableHtml: true,});
                    }
                }

                if (TransporterName == 'Smartr Logistics') {
                    this.toastr.error(msg.total_failure[0].error, 'Error');
                }

                if (TransporterName == 'TCI Express') {
                    this.toastr.error(msg.error, 'Error');
                }

                if (TransporterName == 'Bluedart') {
                    var dd = msg['error-response'];
                    var ddList: any = [];
                    dd.forEach(element => {
                    ddList.push(element.Status[0].StatusInformation);
                    });
                    const commaSeparatedString = ddList.join(', ');
                    this.toastr.error(commaSeparatedString, 'Error');
                }

                if (TransporterName == 'DTDC') {
                    var dd = msg['data'];
                    var ddList: any = [];
                    dd.forEach(element => {
                    ddList.push(element.message);
                    });
                    const commaSeparatedString = ddList.join(', ');
                    this.toastr.error(commaSeparatedString, 'Error');
                }

                if (TransporterName == 'Safexpress') {
                    const descriptions = msg.data.responseData.waybillApiResponse
                    .flatMap(item => item.response.map(r => r.description))
                    .join(', ');

                    this.toastr.error(descriptions, 'Error');
                }

                Helpers.setLoading(false);
                }
                console.log(response);
            },
            (err) => {
                console.log(err);
                // this.toastr.error(err._body.replace(/"/g, ""), "Error");
                Helpers.setLoading(false);
            }
            );
        });
    }
}
